<template>
  <div class="modal is-wide" @click.self="cancel">
    <div class="modal-container is-animated scale-up">
      <div class="modal-image">
        <slot />
      </div>
      <header class="modal-header">{{ header }}</header>
      <div class="modal-body">
        <div>
          <div class="regular-type">{{ body }}</div>
        </div>
      </div>
      <footer class="modal-footer">
        <button v-if="!!cancelText" class="text-button" @click="cancel">{{ cancelText }}</button>
        <button v-else class="text-button" @click="cancel" v-t>Cancel</button>
        <button v-if="actionText" class="text-button" @click="action">{{ actionText }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { isUrl } from 'bits/url'
import { extractUrl } from 'bits/html_parser'
import { __ } from 'bits/intl'
import t from 'vuedirectives/t'
import EscapeToCancelMixin from 'vuemixins/escape_to_cancel_mixin'

export default {
  directives: { t },
  mixins: [EscapeToCancelMixin],
  props: ['header', 'body', 'actionText', 'cancelText'],
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    action() {
      this.$emit('action')
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-image {
  line-height: 0px;
  img {
    width: 448px;
    height: 224px;
  }
}
.modal-header {
  padding: 16px 24px 0px;
}
</style>
